import React,{useEffect, useState, useContext, Fragment,useRef} from 'react';
import Toggle from "../../ReusableComponents/ToggleBtn/ToggleBtn"
import {Row,Col } from 'react-bootstrap'
import DateFnsUtils from '@date-io/date-fns';
import {
  MuiPickersUtilsProvider,
  KeyboardTimePicker,
  KeyboardDatePicker,
  KeyboardDateTimePicker
} from '@material-ui/pickers';
import { makeStyles } from '@material-ui/core/styles';
import Popover from '@material-ui/core/Popover';
import OverlayTrigger from 'react-bootstrap/OverlayTrigger';
// import Popover from 'react-bootstrap/Popover'
import {ReactComponent as DatepickerIcon} from '../../Icons/DatepickerIcon.svg'
import styles2 from '../css/TableRow.module.css'
import styles from '../css/COLUMN.module.css'
import {AppContext} from '../../Resources/CanvasContextFile'
import { StyleSheet, css } from 'aphrodite';
import {CSSPreparation1} from '../../components/Properties/CSSPreparation1.jsx';
import PrepareCSSClass from '../../components/IFormDesignerLayout/PrepareCSSClass';
import NumberFormat from "react-number-format";
import Button from '@material-ui/core/Button';
import Radio from '@material-ui/core/Radio';
import RadioGroup from '@material-ui/core/RadioGroup';
import FormControlLabel from '@material-ui/core/FormControlLabel';
import {IconButton, InputAdornment, TextField} from '@material-ui/core';
import Dots from "../../Icons/ThreeDots.jsx";
import PickListPopup from '../../components/IFormDesignerLayout/IFormDesignerComponents/PicklistProperties/PickListPopup';
import MoreHorizIcon from '@material-ui/icons/MoreHoriz';
import {ThemeJSON} from '../../components/IFormDesignerLayout/Theme/ThemeJSON';
import { functions } from '../../components/IFormDesignerLayout/ApplicationAPI/applicationApi.js';
import { decryptMessage } from '../../components/IFormDesignerLayout/IFormDesignerLogic.jsx';
const useStyles0 = makeStyles((theme)=>({
    root :{
        "& .MuiPopover-paper" : {
            maxWidth:'100%',
            // width:'100%',
            height:'200px',
            maxHeight:'200px'
        }
    }

}))


const useStyles = makeStyles({
    textfieldRoot: {
        "& .MuiFormControl-root": {
            width: '100%',
            display:'flex'
        },
        "& .MuiInputBase-root":{
            marginTop:"auto",
            marginBottom:"auto",
            lineHeight:"28px !important"
        },
        "& .MuiTextField-root" :{
            width:'100%',
            display:'flex'
        },
        "& .MuiInputBase-input":{
          padding: "0px"
        },
      "& label.Mui-focused": {
        color: "white",
      },
      "& .MuiInput-underline:before": {
        //   borderBottom: 'none'
        border:"1px solid transparent !important",
        // borderRadius: "2px",
      },
      "& .MuiButtonBase-root": {
        marginRight: "0px !important"
      },
      "& .MuiInputAdornment-positionEnd":{
        marginTop:"0px",
        marginLeft:"0px !important"
      },
      "& .MuiOutlinedInput-adornedEnd":{
        paddingRight:"0px !important"
      },
      "& .MuiOutlinedInput-root": {
        "& fieldset": {
        },
      },
    },
    textfieldRoot2: {
        pointerEvents: "none",
        "& .MuiFormControl-root": {
            width: '100%',
            display:'flex'

        },
        "& .MuiInputBase-root":{
            marginTop:"auto",
            marginBottom:"auto"
        },
        "& .MuiTextField-root" :{
            width:'100%',
            display:'flex'
        },
        "& .MuiInputBase-input":{
            padding: "0px"
          },
      "& label.Mui-focused": {
        color: "white",
      },
      "& .MuiInput-underline:before": {
        //   borderBottom: 'none'
        // border:"1px solid #c4c4c4",
        borderRadius: "2px",
      },
      "& .MuiInputAdornment-positionEnd":{
        marginTop:"0px",
        
      },
      
      "& .MuiOutlinedInput-root": {
        "& fieldset": {
        },
      },
    }
})



export function TableTextbox(props){ 
    
    const alpha = "A-Za-z";
    const number= "0-9";
    const space = "\\s";
    const specCharSet = "`!@#$%^&*()_+\\-=\\[\\]{};':\"\\\\|,.<>\\/?~";
    let {AllowAlphabets,AllowNumbers,AllowSpaces,AllowSpecialChars,ColumnMaxLength,ColumnMinValue,ColumnMaxValue,AllowSpecialCharsContent} = props.style;
    var AllowFloat = "false";
    AllowSpecialChars=props.style.AllowSpecialchars;
    if(props.rowStyle.complexFieldType === "Integer" || props.rowStyle.complexFieldType === "Long"){
        AllowAlphabets = "false";
        AllowNumbers = "true";
        AllowSpaces = "false";
        AllowSpecialChars = "false"
        // AllowSpecialCharsContent = "false"
        if(props.rowStyle.complexFieldType === "Integer")
        {
            if(!ColumnMinValue){
                ColumnMinValue = -2147483648
        }
        if(!ColumnMaxValue){
            ColumnMaxValue = 2147483647
        }
       }
       else{
        if(!ColumnMinValue){
            ColumnMinValue = -9223372036854775808 
        }
        if(!ColumnMaxValue){
            ColumnMaxValue = 9223372036854775807
        }
       }
    }else if(props.rowStyle.complexFieldType === "Float"){
        AllowAlphabets = "false";
        AllowNumbers = "false";
        AllowSpaces = "false";
        AllowSpecialChars = "false"
        // AllowSpecialCharsContent = "false"
        AllowFloat = "true";
    }
    

    const [inputValue,setInputValue] = useState("")

    useEffect(()=>{
        if(props.defaultValue)
        {
        setInputValue(props.defaultValue)
        }
    },[])

    if(AllowSpecialChars == undefined){
        AllowSpecialChars = 'false'
    }
    if(AllowSpecialCharsContent == undefined || AllowSpecialChars == "false" || AllowSpecialCharsContent == "" ){
        AllowSpecialCharsContent = specCharSet;
    }

    
    const specialChar= AllowSpecialCharsContent;
    let newSpecChar ="" ;
    if(specialChar){
        for(let i =0;i<specialChar.length;i++){
            newSpecChar += "\\" + specialChar[i]
        }
    }
    
    

    function handleChange(e){
    
    const regex1=/^[^A-Za-z0-9\s`!@#$%^&*()_+\-=\[\]{};':"\\|,.<>\/?~]+$/ ;
    if(props.style && AllowNumbers  ==="false" && AllowAlphabets==="false" && AllowSpaces ==="false" && AllowSpecialChars === "false"){
        
        if (e.target.value === "" || regex1.test(e.target.value))
        {
                    setInputValue(e.target.value);
        }
    }

    
    if( props.style && AllowNumbers==="false" && AllowAlphabets==="true" && AllowSpaces==="true" && AllowSpecialChars === "true"){
        var reg = new RegExp("^[^" + number + "]+$");
        if (e.target.value === "" || reg.test(e.target.value))
        {
                    setInputValue(e.target.value);
        }
    }

  
    if(props.style && AllowAlphabets==="false" && AllowNumbers==="true" && AllowSpaces==="true" && AllowSpecialChars === "true"){
        var reg = new RegExp("^[^" + alpha + "]+$");
        if (e.target.value === "" || reg.test(e.target.value))
        {
                    setInputValue(e.target.value);
        }
    }

  
    if( props.style && AllowSpaces==="false" && AllowAlphabets==="true" && AllowNumbers==="true" && AllowSpecialChars === "true"){
        var reg = new RegExp("^[^" + space  + "]+$");
        if (e.target.value === "" || reg.test(e.target.value))
        {
                    setInputValue(e.target.value);
        }
    }

  
    if( props.style && AllowSpecialChars==="false" && AllowAlphabets==="true" && AllowNumbers==="true" && AllowSpaces === "true"){
    
        var reg = new RegExp("^[^" + specialChar  + "]+$");
        
        if (e.target.value === "" || reg.test(e.target.value))
        {

                    setInputValue(e.target.value);
        }
    }

 
    if(props.style &&AllowNumbers==="false" && AllowAlphabets==="false" && AllowSpecialChars==="false" && AllowSpaces==="true" ){
        var reg = new RegExp("^[^" +alpha + number + specialChar  + "]+$");
        if (e.target.value === "" || reg.test(e.target.value))
        {
                    setInputValue(e.target.value);
        }
    }


    if(props.style && AllowNumbers==="true" && AllowAlphabets==="false"  && AllowSpaces==="false" && AllowSpecialChars==="false" && AllowFloat==="false"){
        // var reg = new RegExp("^[^" +alpha + space + specialChar  + "]+$");
        var reg = new RegExp(/^[0-9]*$/);
        if (e.target.value === "" || reg.test(e.target.value))
        {
            if(e.target.value >= ColumnMinValue && e.target.value <= ColumnMaxValue){
                setInputValue(e.target.value);
            }
                    
        }
    }
    //check for float mapped variable
    if(props.style && AllowNumbers==="false" && AllowFloat==="true" && AllowAlphabets==="false"  && AllowSpaces==="false" && AllowSpecialChars==="false"){
        var reg = new RegExp(/^\-?\d*\.?\d{0,2}$/);
        if (e.target.value === "" || reg.test(e.target.value))
        {
                    setInputValue(e.target.value);
        }
    }


    if(props.style && AllowAlphabets==="true" && AllowNumbers==="false"  && AllowSpaces==="false" && AllowSpecialChars==="false"){
        var reg = new RegExp("^[^" + number + space +specialChar  + "]+$");
        if (e.target.value === "" || reg.test(e.target.value))
        {
                    setInputValue(e.target.value);
        }
    }


    if(props.style && AllowSpecialChars==="true" && AllowNumbers==="false"  && AllowSpaces==="false" && AllowAlphabets==="false"){
        var reg = new RegExp( "^[" + newSpecChar + "]+$");
        
        // console.log("myreg -- ",reg)
        if (e.target.value === "" || reg.test(e.target.value))
        {
                    setInputValue(e.target.value);
        }
    }

    
    if(props.style && AllowSpecialChars==="false" && AllowNumbers==="true"  && AllowSpaces==="false" && AllowAlphabets==="true"){
        var reg = new RegExp("^[^" + space +specialChar  + "]+$");
        if (e.target.value === "" || reg.test(e.target.value))
        {
                    setInputValue(e.target.value);
        }
    }

    if(props.style && AllowSpecialChars==="false" && AllowNumbers==="false"  && AllowSpaces==="true" && AllowAlphabets==="true"){
        var reg = new RegExp("^[^"+ number +specialChar  + "]+$");
        if (e.target.value === "" || reg.test(e.target.value))
        {
                    setInputValue(e.target.value);
        }
    }

    if(props.style && AllowSpecialChars==="true" && AllowNumbers==="false"  && AllowSpaces==="false" && AllowAlphabets==="true"){
        var reg = new RegExp("^[^" + number + space + specCharSet + "]+$");
        var reg1 = new RegExp( "[" + newSpecChar + "]+$");

        if (e.target.value === "" || reg.test(e.target.value))
        {
                    setInputValue(e.target.value);
        }else if (e.target.value === "" || reg1.test(e.target.value))
        {
                    setInputValue(e.target.value);
        }
    }

    if(props.style && AllowSpecialChars==="false" && AllowNumbers==="true"  && AllowSpaces==="true" && AllowAlphabets==="false"){
        var reg = new RegExp("^[^" +alpha +specialChar  + "]+$");
        if (e.target.value === "" || reg.test(e.target.value))
        {
                    setInputValue(e.target.value);
        }
    }

    if(props.style && AllowSpecialChars==="true" && AllowNumbers==="true"  && AllowSpaces==="false" && AllowAlphabets==="false"){
        var reg = new RegExp("^[^" +alpha + space +  specCharSet +"]+$");
        var reg1 = new RegExp( "[" + newSpecChar + "]+$");
        if (e.target.value === "" || reg.test(e.target.value))
        {
                    setInputValue(e.target.value);
        }else if (e.target.value === "" || reg1.test(e.target.value))
        {
                    setInputValue(e.target.value);
        }
    }

    if(props.style && AllowSpecialChars==="true" && AllowNumbers==="false"  && AllowSpaces==="true" && AllowAlphabets==="false"){
        var reg = new RegExp("^[^" +alpha + number + specCharSet +"]+$");
        var reg1 = new RegExp( "[" + newSpecChar + "]+$");
        if (e.target.value === "" || reg.test(e.target.value))
        {
                    setInputValue(e.target.value);
        }else if (e.target.value === "" || reg1.test(e.target.value))
        {
                    setInputValue(e.target.value);
        }
    }
    // const regex8= /[ `!@#$%^&*()_+\-=\[\]{};':"\\|,.<>\/?~]/;
    // if(props.style && AllowAlphabets==="true" && AllowNumbers==="false"  && AllowSpaces==="false"){
    //     if (e.target.value === "" || regex8.test(e.target.value))
    //     {
    //                 setInputValue(e.target.value);
    //     }
    // }

    if(props.style && AllowNumbers==="true" && AllowAlphabets==="true" && AllowSpaces==="true" && AllowSpecialChars==="true"){
                    setInputValue(e.target.value);
    }
         
    }



    var formatValue=props.style && props.style["ColumnMasking"];
    var pincodeValue=0;

    if(props.style["ColumnMasking"] === "000-000"){
        // console.log("clickOBliurInputBox76543 ", props.style["ColumnMasking"]);
        formatValue="###-###";
        pincodeValue=1;
    }

    if(props.style["ColumnMasking"] === "(00) 0000000000"){
        formatValue="(00) ##########";
        pincodeValue=1;
    } 

    return(
      <>
         {props.style && props.style["ColumnMasking"] && props.style["ColumnMasking"] !== "nomasking"  ?
        <> 
        <NumberFormat
    //    format="+1 (00) 0##-###"
        // format={formatValue}
        format={pincodeValue === 1 ? formatValue : null}
         mask="_"
        style={{width:"100%",border:"none", outline:"none"}}
        thousandsGroupStyle={props.style && (props.style["ColumnMasking"]==="currency_rupees"
            || props.style["ColumnMasking"]==="dgroup2")
            ? 'lakh' : 'thousand'}
        prefix={props.style && props.style["ColumnMasking"]==="currency_dollar" ?  "$ " 
        : props.style && props.style["ColumnMasking"]==="currency_euro" ?  "€ " :
        props.style && props.style["ColumnMasking"]==="currency_yen" ?  "¥ " :
        props.style && props.style["ColumnMasking"]==="currency_naira" ?  "₦ " :
        props.style && props.style["ColumnMasking"]==="U.S Format (123,456)" ?  "" :
        props.style && props.style["ColumnMasking"]==="currency_rupees" ?  "₹ " :
        props.style && props.style["ColumnMasking"]==="currency_bahamas" ?  "B$ " :
        ""}

        suffix={props.style && props.style["ColumnMasking"]==="Percentage" ?  " %" :
        props.style && props.style["ColumnMasking"]==="currency_french" ?  " CHF" :
        ""}
        onChange={(e)=>handleChange(e)}
        onBlur={(event)=>props.handleRowData(event.target.value)}

        value={props.style.columnCharacterSet === "lowercase" ? inputValue.toLocaleLowerCase() :
        props.style.columnCharacterSet === "uppercase" ?
         inputValue.toLocaleUpperCase() :
         inputValue
        }
        onFocus={()=>{props.currentCell.current = {rowIndex:props.rowIndex,colIndex:props.colIndex}}}
        decimalSeparator="."
        displayType="input"
        type="text"
        thousandSeparator={true}
        allowNegative={true}
        onKeyPress={(e)=>{
            if(window.onTableCellKeyPress){
            window.onTableCellKeyPress(props.id,props.colIndex,e)
            functions.updateJSON();
            }
            console.log('keyPressed')
        }}
    />

    </>

    :  <>

    

      <input type="text" 
    //   style={props.rowStyle && props.rowStyle.BackColor !=undefined ? {backgroundColor:props.rowStyle && props.rowStyle.BackColor}:null}
       autoFocus={props.showEditable} readOnly={false} 
             className={styles2.dataAdditionRowTextbox + " control-class" +  ' tableRowDefaultStyle_' + props.id}
                        style={{
                            ...(props.rowStyle?.BackColor !== undefined && { backgroundColor: props.rowStyle.BackColor }),
                            width: "100%",
                            border: "none",
                            outline: "none",
                            color: "inherit",
                            fontWeight: 400,
                        }}

            //  style={{width:"100%",border:"none", outline:"none",color:"inherit",fontWeight:400}}
            //  defaultValue={props.defaultValue} 
             disabled={props.rowStyle && props.rowStyle.Enable !=undefined ?  (props.rowStyle.Enable==="true" ? false : true) :  (props.tableStyle && props.tableStyle.Enable==="true" ? false : true)}
             onBlur={(event)=>props.handleRowData(event.target.value)}
             autofocus={props.currentCell && props.currentCell.current && props.currentCell.current.colIndex === props.colIndex && props.currentCell.current.rowIndex === props.rowIndex}

             value={props.style.columnCharacterSet === "lowercase" ? inputValue.toLocaleLowerCase() :
             props.style.columnCharacterSet === "uppercase" ?
              inputValue.toLocaleUpperCase() :
              inputValue
             }  
             onFocus={()=>{props.currentCell.current = {rowIndex:props.rowIndex,colIndex:props.colIndex}}}
             onChange={(e)=>handleChange(e)}
            maxLength={ColumnMaxLength}
             onClick={props.setCurrentEvent}
            ref={(e) => {
                if(props?.inputRef?.current?.[props.index]?.[props.colIndex]) {
                    props.inputRef.current[props.index][props.colIndex] = e
                }
            }
            }
            // min={MinValue}
            // max={MaxValue}  
            />
       
    

     </>}



</>


    )
}

export function TableTextarea(props){

    const alpha = "A-Za-z";
    const number= "0-9";
    const space = "\\s";
    const specCharSet = "`!@#$%^&*()_+\\-=\\[\\]{};':\"\\\\|,.<>\\/?~";
    let {AllowAlphabets,AllowNumbers,AllowSpaces,AllowSpecialChars,ColumnMaxLength,ColumnMinValue,ColumnMaxValue,AllowSpecialCharsContent} = props.style;
    var AllowFloat = "false";
    AllowSpecialChars=props.style.AllowSpecialchars;
    if(props.style.complexFieldType === "Integer" || props.style.complexFieldType === "Long"){
        AllowAlphabets = "false";
        AllowNumbers = "true";
        AllowSpaces = "false";
        AllowSpecialChars = "false"
        // AllowSpecialCharsContent = "false"
        if(!ColumnMinValue){
            ColumnMinValue = -2147483648
        }
        if(!ColumnMaxValue){
            ColumnMaxValue = 2147483647
        }
    }else if(props.style.complexFieldType === "Float"){
        AllowAlphabets = "false";
        AllowNumbers = "false";
        AllowSpaces = "false";
        AllowSpecialChars = "false"
        // AllowSpecialCharsContent = "false"
        AllowFloat = "true";
    }
    else if(props.style.complexFieldType === "String" || props.style.complexFieldType === "NText" ){
        AllowAlphabets = "true";
        AllowNumbers = "true";
        AllowSpaces = "true";
        AllowSpecialChars = "true"
        // AllowSpecialCharsContent = "false"
        
    }

    const [inputValue,setInputValue] = useState("")

    useEffect(()=>{
        if(props.defaultValue)
        {
        setInputValue(props.defaultValue)
        }
    },[])
    
    const specialChar= AllowSpecialCharsContent;
    let newSpecChar ="" ;
    if(specialChar){
        for(let i =0;i<specialChar.length;i++){
            newSpecChar += "\\" + specialChar[i]
        }
    }
    

    function handleChange(e){
    
        const regex1=/^[^A-Za-z0-9\s`!@#$%^&*()_+\-=\[\]{};':"\\|,.<>\/?~]+$/ ;
        if(props.style && AllowNumbers  ==="false" && AllowAlphabets==="false" && AllowSpaces ==="false" && AllowSpecialChars === "false"){
            
            if (e.target.value === "" || regex1.test(e.target.value))
            {
                        setInputValue(e.target.value);
            }
        }
    
        
        if( props.style && AllowNumbers==="false" && AllowAlphabets==="true" && AllowSpaces==="true" && AllowSpecialChars === "true"){
            var reg = new RegExp("^[^" + number + "]+$");
            if (e.target.value === "" || reg.test(e.target.value))
            {
                        setInputValue(e.target.value);
            }
        }
    
      
        if(props.style && AllowAlphabets==="false" && AllowNumbers==="true" && AllowSpaces==="true" && AllowSpecialChars === "true"){
            var reg = new RegExp("^[^" + alpha + "]+$");
            if (e.target.value === "" || reg.test(e.target.value))
            {
                        setInputValue(e.target.value);
            }
        }
    
      
        if( props.style && AllowSpaces==="false" && AllowAlphabets==="true" && AllowNumbers==="true" && AllowSpecialChars === "true"){
            var reg = new RegExp("^[^" + space  + "]+$");
            if (e.target.value === "" || reg.test(e.target.value))
            {
                        setInputValue(e.target.value);
            }
        }
    
      
        if( props.style && AllowSpecialChars==="false" && AllowAlphabets==="true" && AllowNumbers==="true" && AllowSpaces === "true"){
        
            var reg = new RegExp("^[^" + specialChar  + "]+$");
            
            if (e.target.value === "" || reg.test(e.target.value))
            {
    
                        setInputValue(e.target.value);
            }
        }
    
     
        if(props.style &&AllowNumbers==="false" && AllowAlphabets==="false" && AllowSpecialChars==="false" && AllowSpaces==="true" ){
            var reg = new RegExp("^[^" +alpha + number + specialChar  + "]+$");
            if (e.target.value === "" || reg.test(e.target.value))
            {
                        setInputValue(e.target.value);
            }
        }
    
    
        if(props.style && AllowNumbers==="true" && AllowAlphabets==="false"  && AllowSpaces==="false" && AllowSpecialChars==="false" && AllowFloat==="false"){
            // var reg = new RegExp("^[^" +alpha + space + specialChar  + "]+$");
            var reg = new RegExp(/^[0-9]*$/);
            if (e.target.value === "" || reg.test(e.target.value))
            {
                if(e.target.value >= ColumnMinValue && e.target.value <= ColumnMaxValue){
                    setInputValue(e.target.value);
                }
                        
            }
        }
        //check for float mapped variable
        if(props.style && AllowNumbers==="false" && AllowFloat==="true" && AllowAlphabets==="false"  && AllowSpaces==="false" && AllowSpecialChars==="false"){
            var reg = new RegExp(/^\-?\d*\.?\d{0,2}$/);
            if (e.target.value === "" || reg.test(e.target.value))
            {
                        setInputValue(e.target.value);
            }
        }
    
    
        if(props.style && AllowAlphabets==="true" && AllowNumbers==="false"  && AllowSpaces==="false" && AllowSpecialChars==="false"){
            var reg = new RegExp("^[^" + number + space +specialChar  + "]+$");
            if (e.target.value === "" || reg.test(e.target.value))
            {
                        setInputValue(e.target.value);
            }
        }
    
    
        if(props.style && AllowSpecialChars==="true" && AllowNumbers==="false"  && AllowSpaces==="false" && AllowAlphabets==="false"){
            var reg = new RegExp( "^[" + newSpecChar + "]+$");
            
            // console.log("myreg -- ",reg)
            if (e.target.value === "" || reg.test(e.target.value))
            {
                        setInputValue(e.target.value);
            }
        }
    
        
        if(props.style && AllowSpecialChars==="false" && AllowNumbers==="true"  && AllowSpaces==="false" && AllowAlphabets==="true"){
            var reg = new RegExp("^[^" + space +specialChar  + "]+$");
            if (e.target.value === "" || reg.test(e.target.value))
            {
                        setInputValue(e.target.value);
            }
        }
    
        if(props.style && AllowSpecialChars==="false" && AllowNumbers==="false"  && AllowSpaces==="true" && AllowAlphabets==="true"){
            var reg = new RegExp("^[^"+ number +specialChar  + "]+$");
            if (e.target.value === "" || reg.test(e.target.value))
            {
                        setInputValue(e.target.value);
            }
        }
    
        if(props.style && AllowSpecialChars==="true" && AllowNumbers==="false"  && AllowSpaces==="false" && AllowAlphabets==="true"){
            var reg = new RegExp("^[^" + number + space + specCharSet + "]+$");
            var reg1 = new RegExp( "[" + newSpecChar + "]+$");
    
            if (e.target.value === "" || reg.test(e.target.value))
            {
                        setInputValue(e.target.value);
            }else if (e.target.value === "" || reg1.test(e.target.value))
            {
                        setInputValue(e.target.value);
            }
        }
    
        if(props.style && AllowSpecialChars==="false" && AllowNumbers==="true"  && AllowSpaces==="true" && AllowAlphabets==="false"){
            var reg = new RegExp("^[^" +alpha +specialChar  + "]+$");
            if (e.target.value === "" || reg.test(e.target.value))
            {
                        setInputValue(e.target.value);
            }
        }
    
        if(props.style && AllowSpecialChars==="true" && AllowNumbers==="true"  && AllowSpaces==="false" && AllowAlphabets==="false"){
            var reg = new RegExp("^[^" +alpha + space +  specCharSet +"]+$");
            var reg1 = new RegExp( "[" + newSpecChar + "]+$");
            if (e.target.value === "" || reg.test(e.target.value))
            {
                        setInputValue(e.target.value);
            }else if (e.target.value === "" || reg1.test(e.target.value))
            {
                        setInputValue(e.target.value);
            }
        }
    
        if(props.style && AllowSpecialChars==="true" && AllowNumbers==="false"  && AllowSpaces==="true" && AllowAlphabets==="false"){
            var reg = new RegExp("^[^" +alpha + number + specCharSet +"]+$");
            var reg1 = new RegExp( "[" + newSpecChar + "]+$");
            if (e.target.value === "" || reg.test(e.target.value))
            {
                        setInputValue(e.target.value);
            }else if (e.target.value === "" || reg1.test(e.target.value))
            {
                        setInputValue(e.target.value);
            }
        }
        // const regex8= /[ `!@#$%^&*()_+\-=\[\]{};':"\\|,.<>\/?~]/;
        // if(props.style && AllowAlphabets==="true" && AllowNumbers==="false"  && AllowSpaces==="false"){
        //     if (e.target.value === "" || regex8.test(e.target.value))
        //     {
        //                 setInputValue(e.target.value);
        //     }
        // }
    
        if(props.style && AllowNumbers==="true" && AllowAlphabets==="true" && AllowSpaces==="true" && AllowSpecialChars==="true"){
                        setInputValue(e.target.value);
        }
             
        }

    const classes=useStyles0();
    const[anchorEl, setAnchorEl] =React.useState(null);
    const open=Boolean(anchorEl);
    const id=open?'simple-popover':undefined;
    const[editable, setEditable] = useState(false);

    
    function handleClick(currentTarget){
        setEditable(true);
        setAnchorEl(currentTarget);
    }
    function handleClose(){
        setAnchorEl(null);
        setEditable(null);
    }
    
    function showTextArea(value){
        setEditable(false);
        props.handleRowData(value);
    }

    return(
        //   editable === true ?

        editable === "" ?
            
             <div className={styles2.dataAdditionRowTextareaDiv+" control-class"} key={props.defaultValue} 
             style={props.rowStyle && props.rowStyle.BackColor !=undefined ? {backgroundColor:props.rowStyle && props.rowStyle.BackColor}:null}
             disabled={props.rowStyle && props.rowStyle.Enable !=undefined ?  (props.rowStyle.Enable==="true" ? false : true) :  (props.tableStyle && props.tableStyle.Enable==="true" ? false : true)}
               >
                     <textarea key={props.defaultValue} 
                       //className={styles2.editableTextArea + ' ' + 'tableRowDefaultStyle_' + props.id} 
                        defaultValue={props.defaultValue} 
                        id={props.rowIndex+props.style.ColumnName}
                        onBlur={(event)=>showTextArea(event.target.value)}
                        value={props.style.columnCharacterSet === "lowercase" ? inputValue.toLocaleLowerCase() :
                        props.style.columnCharacterSet === "uppercase" ?
                         inputValue.toLocaleUpperCase() :
                         inputValue
                        }
                        onChange={(e)=>handleChange(e)}
                        maxLength={ColumnMaxLength}
                        />
            </div> 
            
            :  
            
            // <input
            <textarea
             type="text" key={editable + props.defaultValue} contentEditable={false} 
            //  className={styles2.dataAdditionRowTextbox } 
             className={styles2.dataAdditionRowTextarea}
            defaultValue={props.defaultValue} 
            id={props.rowIndex+props.style.ColumnName}
            // onClick={(event)=>handleClick(event.currentTarget)}
            style={props.rowStyle && props.rowStyle.BackColor !=undefined ? {backgroundColor:props.rowStyle && props.rowStyle.BackColor}:null}
           
            onBlur={(event)=>showTextArea(event.target.value)}
            value={props.style.columnCharacterSet === "lowercase" ? inputValue.toLocaleLowerCase() :
            props.style.columnCharacterSet === "uppercase" ?
             inputValue.toLocaleUpperCase() :
             inputValue
            }
            onChange={(e)=>handleChange(e)}
            maxLength={ColumnMaxLength}

            disabled={props.rowStyle && props.rowStyle.Enable !=undefined ?  (props.rowStyle.Enable==="true" ? false : true) :  (props.tableStyle && props.tableStyle.Enable==="true" ? false : true)}
            // onBlur={(event)=>showTextArea(event.target.value)}
            />
    )
}

export function TableToggle(props){
    return(
        <div
        className={styles.toggleTableRowClass}
        >
        {/* <Toggle previewmode={true} key={props.defaultValue} handleToggleRef={(event)=>props.handleRowData(event.current)}  */}
        <Toggle previewmode={true} key={props.defaultValue} handleToggle={(event)=>props.handleRowData(event.target.value)} handleToggleRef={(event)=>props.handleRowData(event.current)} 
            toggleState={props.defaultValue} customStyle={{'display':'flex', 'justifyContent': 'center !important',backgroundColor:props.rowStyle && props.rowStyle.BackColor}}
            // disabled={props.tableStyle && props.tableStyle.Enable==="true" ? false : true}
            disabled={props.rowStyle && props.rowStyle.Enable !=undefined ?  (props.rowStyle.Enable==="true" ? false : true) :  (props.tableStyle && props.tableStyle.Enable==="true" ? false : true)}
            />
        <span className="toggleStateSpan" style={{fontSize:"12px"}}>
        {props.style["ToggleStates"] === "CustomState" ? (props.defaultValue==="true") ? props.style.ToggleState2: props.style.ToggleState1 : null}
        </span>
        </div>
    )
}

export function TableCheckbox(props){ 
    const [checkboxValue,setCheckboxValue] = useState(props.defaultValue || false)
    return(
        <>
        {(props.rowStyle && props.rowStyle.Enable !=undefined ?  (props.rowStyle.Enable==="true" ? true : false) :  (props.tableStyle && props.tableStyle.Enable==="true" ? true : false))? <div style={{display:"flex",justifyContent:"center"}}>
        <input type="checkbox" readOnly={false} key={props.defaultValue} name={props.rowIndex+'_' + props.style.ColumnName} 
            className={styles2.dataAdditionRowCheckbox} defaultChecked={checkboxValue ===  "true" ? true : false}
            checked={checkboxValue}
            onClick={()=>{
                setCheckboxValue(!checkboxValue)
                props.handleRowData(props.defaultValue ===  true? false : true )
                
            }}
            style={props.rowStyle && props.rowStyle.BackColor !=undefined ? {backgroundColor:props.rowStyle && props.rowStyle.BackColor}:null}
            // disabled={ props.tableStyle && props.tableStyle.Enable==="true" ? false : true}
            //  disabled={false}
            /></div>
            :
            <div style={{display:"flex",justifyContent:"center"}}>
            <input type="checkbox" readOnly={false} key={props.defaultValue} name={props.rowIndex+'_' + props.style.ColumnName} 
            className={styles2.dataAdditionRowCheckbox} defaultChecked={props.defaultValue ===  "true"? true : false}
            onClick={()=>{
                setCheckboxValue(!checkboxValue)
                props.handleRowData(props.defaultValue ===  true? false : true )
            }}
            style={props.rowStyle && props.rowStyle.BackColor !=undefined ? {backgroundColor:props.rowStyle && props.rowStyle.BackColor}:null}
            // disabled={ props.tableStyle && props.tableStyle.Enable==="true" ? false : true}
             disabled={true}
            /></div>}
            </>
    )
}

export function TableDatepicker(props){
    const classes = useStyles();
    var enableProperty ={ root: classes.textfieldRoot } 
//     var enableProperty = (props.rowStyle && props.rowStyle.Enable !=undefined ?  (props.rowStyle.Enable==="true" ? true : false) : (props.tableStyle && props.tableStyle.Enable==="true")) ?
//   { root: classes.textfieldRoot } 
  
//   :
//   { root: classes.textfieldRoot };

  const [dateValue,setDateValue] = useState(null)
//   { root: classes.textfieldRoot2 };

    return(
            <MuiPickersUtilsProvider utils={DateFnsUtils} key={props.defaultValue}>
            {/* <Fragment> */}
                <KeyboardDatePicker

                    // classes={(
                    //     props.tableStyle && props.tableStyle.Enable==="true" ?
                    //     root: classes.textfieldRoot : null
                    // )}

                    classes={enableProperty}
                    elem_type='datepick' 
                    style={{display:'flex', flexDirection: 'unset !important', 
                     height:'100%',
                    //height:'50px',
                    padding:'4px 4px 0px 4px',backgroundColor:props.rowStyle && props.rowStyle.BackColor}}
                    keyboardIcon={<DatepickerIcon/>}
                    showTodayButton
                    clearable
                    // openTo="year"
                    openTo="date"
                    format={props.dateFormat ? props.dateFormat : 'dd/MM/yyyy'}
                    value={props.defaultValue ? props.defaultValue : dateValue }
                    {...(props.rowStyle&& props.rowStyle.minDate && { minDate: props.rowStyle.minDate })}
                    {...(props.rowStyle&& props.rowStyle.maxDate && { maxDate: props.rowStyle.maxDate })}
                    minDate={props.rowStyle&& props.rowStyle.minDate}
                    maxDate={props.rowStyle&& props.rowStyle.maxDate}
                    onChange={() => undefined}
                    onAccept={date => {
                        setDateValue(date)
                        props.handleRowData(date)
                    }}
                    onBlur={date => props.handleOnBlurDate(date)}
                />
              {/* </Fragment> */}
            </MuiPickersUtilsProvider> 
    )
}   

export function TableDateTimepicker(props){
    const classes = useStyles();
    var enableProperty ={ root: classes.textfieldRoot } 
//     var enableProperty = (props.rowStyle && props.rowStyle.Enable !=undefined ?  (props.rowStyle.Enable==="true" ? true : false) : (props.tableStyle && props.tableStyle.Enable==="true")) ?
//   { root: classes.textfieldRoot } 
  
//   :
//   { root: classes.textfieldRoot };
//   { root: classes.textfieldRoot2 };
const [dateValue,setDateValue] = useState(null)
    return(
            <MuiPickersUtilsProvider utils={DateFnsUtils} key={props.defaultValue}>
            {/* <Fragment> */}
                {/* <KeyboardDatePicker

                    // classes={(
                    //     props.tableStyle && props.tableStyle.Enable==="true" ?
                    //     root: classes.textfieldRoot : null
                    // )}

                    classes={enableProperty}
                    elem_type='datepick' 
                    style={{display:'flex', flexDirection: 'unset !important', 
                     height:'100%',
                    //height:'50px',
                    padding:'4px 4px 0px 4px',backgroundColor:props.rowStyle && props.rowStyle.BackColor}}
                    keyboardIcon={<DatepickerIcon/>}
                    showTodayButton
                    clearable
                    // openTo="year"
                    openTo="date"
                    format={props.dateFormat ? props.dateFormat : 'dd/MM/yyyy'}
                    value={props.defaultValue ? props.defaultValue : null }
                    {...(props.rowStyle&& props.rowStyle.minDate && { minDate: props.rowStyle.minDate })}
                    {...(props.rowStyle&& props.rowStyle.maxDate && { maxDate: props.rowStyle.maxDate })}
                    minDate={props.rowStyle&& props.rowStyle.minDate}
                    maxDate={props.rowStyle&& props.rowStyle.maxDate}
                    onChange={date => props.handleRowData(date)}
                /> */}

                <KeyboardDateTimePicker

                classes={enableProperty}

                id={props.id}
                //  control_id={props.id}
                //  control_id={userDefinedControlId}
                elem_type='datepick'
                // style={styling3}
                style={{display:'flex', flexDirection: 'unset !important', 
                     height:'100%',
                    //height:'50px',
                    padding:'4px 4px 0px 4px',backgroundColor:props.rowStyle && props.rowStyle.BackColor}}
                // frameindex={props.data.frameIndex}  elementindex={props.data.elementIndex}
                keyboardIcon={<DatepickerIcon/>}
                fullWidth
                // InputProps={inputStylePreview}
                ampm={false}
                autoOk
                openTo= {"date"}
                // value={selectedDateTime}
                // onChange={date => handleDateTimeChange(date)}
                        // defaultValue={dateDefaultValue}
                value={props.defaultValue ? props.defaultValue : dateValue }

                format={"dd/MM/yyyy, HH:mm"}


                // {...(props.data.style && props.data.style["MinDate"]  && { minDate: props.data.style["MinDate"] })}
                // {...((props.data.style && props.data.style["MinDateAsCurrent"] === "true")&& { minDate: currDate })}
                // {...(props.data.style && props.data.style["MaxDate"]  && { maxDate: props.data.style["MaxDate"] })}
                // {...((props.data.style && props.data.style["MaxDateAsCurrent"]  === "true")&& { maxDate: currDate })}

                // inputRef={elementRefrence}
                // onFocus={(e)=>handleOnFocus(e)}
                // onBlur={(e)=>hadleOnBlur(e)}
                onChange={() => undefined}
                onAccept={date => {
                    setDateValue(date)
                    props.handleRowData(date)
                }}
                onBlur={date => props.handleOnBlurDate(date)}

                inputVariant= {"outlined"}
                size="small"
                // error={showMandatoryMsg}
                // helperText={null}
                />
              {/* </Fragment> */}
            </MuiPickersUtilsProvider> 
    )
}
export function TableRadio(props){
    const [radioValue,setRadioValue] = useState(props?.defaultValue || "")
    return(
        <RadioGroup aria-label={props.style.ColumnName} name={props.style.ColumnName} value={radioValue} onChange={(e)=>{
            setRadioValue(e.target.value)
            props.handleRowData(e.target.value)
        }}>
            {props.style && props.style.options && props.style.options.map((optionDetails, optionIndex)=>{ 
                return(
                    <FormControlLabel style={{margin:0}} value={optionDetails.value} control={<Radio  color="primary"/>} label={optionDetails.label}/>
                        // <div className={[styles2.dataAdditionRowRadioDiv + ' ' + 'tableRowDefaultStyle_' + props.id, props.defaultValue===optionDetails.label ? 
                        //                 styles2.dataAdditionRadioSelectedOption : null].join(" ")} 
                        // style={props.rowStyle && props.rowStyle.BackColor !=undefined ? {backgroundColor:props.rowStyle && props.rowStyle.BackColor}:null}
                        // onClick={()=>props.handleRowData(optionDetails.label)}>{optionDetails.label} </div>
                )   
            })}
        </RadioGroup>
    )
}

export function TableButton(props){
    var buttonDefaultStyle = {
        'height' : 'fit-content',
        'font-size' : props.style?.FontSize || "12px",
        'font-weight' : props.style?.FontWeight || "400",
        'font-family' :  props.style?.FontFamily || "Open Sans",
        // 'font-style' : "normal",
        'background-color' : props.style?.BackgroundColor || "#0072C6",
        'border-width' : '1px',
        'border-style' : 'solid',
        'border-color': props.style?.BorderColor || "#3D6CE9",
        'color' : props.style?.FontColor || "#FFFFFF",
        'border-radius':  props.style?.CornerRadius || "3px",
        "text-transform" : 'none',
        "word-break": "break-word"
    }
    var buttonVariant = ""
    var buttonColor = ""
    if(props.style?.ButtonType === "Primary"){
        buttonVariant= "contained";
        buttonColor = "primary"
    }
    else if(props.style?.ButtonType === "Secondary"){
        buttonVariant= "outlined";
        buttonColor = "primary"
        delete buttonDefaultStyle['background-color']
        delete buttonDefaultStyle['color']
    }else{
        buttonVariant = "contained"
        buttonColor = "primary"
    }
     
    return (<>
    <Button   
    disableFocusRipple
    disableRipple
    tabIndex={0}   
              id={props.id}
              // control_id={props.id}
            //   control_id={userDefinedControlId}
              // onClick={()=>applyChanges()}
              disable={false}
            //   ref={elementRefrence}
            //   onClick={(event)=>subformInPreview(event)}
                // className={[styles2.buttonsStyle, css(styleSheet.styling)].join(" ")} 
                size="small"
                style={buttonDefaultStyle}
                className={`${props.id}` + 'buttonDefaultStyle' + ' formBuilder-MuiButton-outlined'}
                elem_type='button' frameindex={props.data?.frameIndex} elementindex={props.data?.elementIndex}
                disableElevation

                // classes={{
                //   root: classes.buttonLabel
                // }}
                // size="small"
                // variant="contained"
                // color="primary"
                variant={buttonVariant}
                color={buttonColor}
                // startIcon={props.data.style && data.style.IconAlignment && data.style.IconAlignment==='Left'?
                // iconFile && <img className={iconStyle}  src={iconFile} style={{width:FontSize, height:FontSize}}/>:null
                // }
                // endIcon={
                //   // props.data.style && data.style.IconAlignment && data.style.IconAlignment==='Right'?
                //   // iconFile && <img className={iconStyle}  src={iconFile} style={{width:FontSize, height:FontSize}}/>:null
                //   endIconComp
                // }
              >
                <div >
                {props.style?.ButtonLabel}
                </div>
              </Button>
    </>)
}

export function TableDropdown(props){
    function handleCombo(comboId){ 
        var select = document.getElementById(comboId);
        var optionTag = select.options[select.selectedIndex];
        props.handleRowData(optionTag.value);
     }
     var optionList=props.rowStyle && props.rowStyle.options != undefined? props.rowStyle.options :props.style.options;
    return(
        <select className={styles2.dataAdditionRowTextbox+" control-class" } id={props.rowIndex + props.style.ColumnName} 
        disabled={props.rowStyle && props.rowStyle.Enable !=undefined ?  (props.rowStyle.Enable==="true" ? false : true) :  (props.tableStyle && props.tableStyle.Enable==="true" ? false : true)}
        style={props.rowStyle && props.rowStyle.BackColor !=undefined ? {backgroundColor:props.rowStyle && props.rowStyle.BackColor}:null}
           onChange={()=>handleCombo(props.rowIndex + props.style.ColumnName)}>
             {props.defaultValue === undefined || props.defaultValue === '' ?
                <>
                    return (<option value={''} selected></option> )
                </>
                : null
            }
           {optionList && optionList.map((optionDetails,optionCount)=>{
            if(optionDetails.value === props.defaultValue) {
                return <option value={optionDetails.value}
                 selected
                 id={optionDetails.optionId}
                 title={optionDetails.tooltip == undefined || optionDetails.tooltip == null || optionDetails.tooltip == ' '?optionDetails.label:optionDetails.tooltip}
                 >{optionDetails.label} </option>
            } else{
               return <option value={optionDetails.value}
               id={optionDetails.optionId}
               title={optionDetails.tooltip == undefined || optionDetails.tooltip == null || optionDetails.tooltip == ' '?optionDetails.label:optionDetails.tooltip}
               >{optionDetails.label}</option>
             }     
           })}
        </select>
    )
}

export function TableTextboxForCustomControl(props){   
    let value = props?.defaultValue;
    const ref = useRef(null);
    if(props?.decrypted && !props?.defaultValue?.includes('property_value')) {
        value = '';
        ( async() => {
            value = await decryptMessage(props.defaultValue);
            ref.current.value = value;
            ref.current.defaultValue = value;
        } )();
    }
    return(
        <input type="text" style={props.style} 
            autoFocus={props.showEditable}   
            ref={ref}
            className={styles.gridRowHoverEffect + " " + styles2.dataAdditionRowTextbox }
            defaultValue={value} 
            onBlur={(event)=>props.handleRowData(event.target.value)}
            />
    )
}

export function TablePicklist(props){
    const [popup, setPopup] = useState(false);
    const [picklistValue,setPicklistValue] = useState(props.defaultValue || "")
    function handlePopupClose2() {
        setPopup(false);
      }
    function handlePopup(ev){
        let res = true;
        if(window.picklistPreHook){
          res = window.picklistPreHook(props.rowIndex.id);
          functions.updateJSON();
        }
        if(res === false){
          setPopup(false)
        } else {
          setPopup(true)
        }
  
    }
    const pickListStyle = ThemeJSON.picklist
    props.style.id = props.rowIndex.id;
    props.style.PicklistSelectedAll = [];
    props.style.PicklistSelected = "";
    let a = window?.allowSelection?.() ?? false;
    // props.style.PicklistSelectedAll = {};
    const dataObj = {
        data: {
            style: {
                ...props.style,
                ...pickListStyle,
                ...(a ? { AllowMultipleSelection: "true" } : {})
            },
            id: props.rowIndex.id
        }
    };
    
    const classes = useStyles();
    const elementRefrence= useRef(null);
    const iconStyle={height:"14px", width:"15px",verticalAlign:"baseline", marginRight:"6px"}  
    return (
        <><TextField
        fullWidth
        // className={props.data.style["ControlStyle"]!=='Style2' ? classes.textField : null} 
        classes={{
          root: classes.textfieldRoot
        }}
        variant= {"outlined"}          
        // InputProps={inputStyle}
        // icon={}
        ref={elementRefrence}
        // onChange={(e)=>props.handleRowData(e)}
        value={picklistValue}
        // id={userDefinedControlId} 
        // value={valueOfText}
        // control_id={props.id} 
        // control_id={userDefinedControlId} 
        placeholder={''}
        elem_type='textbox'  
        // frameindex={data.frameIndex} elementindex={data.elementIndex} 
        // sheetIndex={data.sheetIndex} sheetElementIndex={data.sheetElementIndex} sheetFrameElementindex={data.sheetFrameElementindex}
        InputProps={{
            endAdornment:(
                <InputAdornment position='end' >
                    <MoreHorizIcon onClick={handlePopup}/>
                </InputAdornment>
            )
        }}
        size="small" 
        disabled = {false}
      />
      { (popup) && 
                        <PickListPopup
                        handleRowData={props.handleRowData}
                          columnId={props.columnId}
                          id={props.id}
                          isEnable = {true}
                          containerId={props.containerId} 
                          data={dataObj.data} 
                          style={dataObj.data.style} 
                        //   onClose={handlePopupClose}
                          onClose={handlePopupClose2}
                          onClose2={handlePopupClose2}
                          open={true} 
                          setPicklistValue={setPicklistValue}
                        />
                      }
        </>
    )
}

 